import {
  FieldObjectSubType,
  FieldObjectType,
  FieldOptionBase,
  FieldTypeDisplay,
} from 'module/api/field/types';
import { SourceType } from 'module/api/filter/types';

export enum FilterContext {
  Automations,
  Others,
}

export enum FieldType {
  Boolean = 'Boolean',
  Number = 'Number',
  Text = 'Text',
  MultiLineText = 'MultiLineText',
  Date = 'Date',
  SingleSelect = 'SingleSelect',
  MultiSelect = 'MultiSelect',
  SingleUser = 'SingleUser',
  MultiUser = 'MultiUser',
  Assignee = 'Assignee',
  Estimate = 'Estimate',
  Note = 'Note',
}
export const UserTypeFields = [
  FieldType.SingleUser,
  FieldType.MultiUser,
  FieldType.Assignee,
];

export interface FieldBase<T> {
  fieldId: number;
  fieldName: string;
  fieldLabel?: string;
  fieldIndex?: number;
  description?: string;
  fieldGroup?: string;
  private: boolean;
  value?: T;
  customField?: boolean;
  metaData?: {
    required?: boolean;
    relatedFieldId?: number;
    allowAdminsAndOwnersToEdit?: boolean;
    captureKeyIntervalForFirstActivityOnly?: boolean;
    options?: FieldOptionBase<number>[];
    roleIds?: number[];
    allowRelativeDateOps?: boolean;
    allowAbsDateOps?: boolean;
    allowBaseOps?: boolean;
    showAllOps?: boolean;
    filterContext?: FilterContext;
  };
  userCreated?: boolean;
  isEnabled?: boolean;
  isEditable?: boolean;
  fieldType?: string;
  label?: string;
  sourceType: SourceType;
  userGroupIds?: number[];
  objectType?: FieldObjectType;
  objectSubType?: FieldObjectSubType;
  fieldTypeDisplay?: FieldTypeDisplay | null;
}
